// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1GBHi","gfeWrapper":"CalendarEvent_gfeWrapper__r1vx0"};